import { Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output } from '@angular/core';
import { FileType } from 'src/app/ads/model/file';
import { FilePreview } from 'src/app/ads/model/file-preview';
import { IconMenuButton } from '../../model/icon-menu-button';
import { PlayerEvent } from '../../model/player-event';
import { SCREEN_ASPECT_CONVERTER } from '../../util/sreen-apect-converter';

@Component({
  selector: 'app-file-player',
  templateUrl: './file-player.component.html',
  styleUrls: ['./file-player.component.scss']
})
export class FilePlayerComponent implements OnInit {

  @Input() set file(f: FilePreview) {
    this.error = false;
    this.filePreview = f;
  };

  @Input() videoControl: PlayerEvent;
  @Input() progress: number = 0;
  @Input() progressEnabled: boolean = false;
  @Input() menuIcons: IconMenuButton[] = [];
  @Input() controls: boolean = false;
  @Output() buttonClicked: EventEmitter<string> = new EventEmitter();
  @Output() pauseTime: EventEmitter<number> = new EventEmitter();
  error: boolean = false;
  height: string;
  width: string;
  filePreview: FilePreview;


  types: typeof FileType = FileType;

  constructor(private elRef: ElementRef, private ngZone: NgZone) { }

  ngOnInit(): void {
    this.setScreenSize();
  }

  private setScreenSize(): void {
    const observe = new ResizeObserver((entries: ResizeObserverEntry[]) => {
      this.ngZone.run(() => {
        const initWidth = entries[0]?.contentRect.width;
        const width = initWidth - 50;
        this.height = `${width / SCREEN_ASPECT_CONVERTER}px`;
        this.width = `${width}px`;
      });
    });
    observe.observe(this.elRef.nativeElement);
  }

  isError(): void {
    this.error = true;
  }
}
